/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vue Monica Refine Design
  Author: Riyan Kurniawan
  -- MONICA --
==========================================================================================*/

const mutations = {
  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  UPDATE_SIDEBAR_WIDTH(state, width) {
    state.sidebarWidth = width
  },
  UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
    state.sidebarItemsMin = val
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val
  },
  TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
    state.isSidebarActive = value
  },
  SET_SIDEBAR_USER_TRIGGERED(state, value) {
    state.sidebarUserTriggered = value
  },
  UPDATE_THEME(state, val) {
    state.theme = val
  },
  UPDATE_WINDOW_BREAKPOINT(state, val) {
    state.breakpoint = val
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val
  },
  UPDATE_USER_ROLE(state, val) {
    state.userRole = val
    localStorage.setItem('userRole', val)
  },
  UPDATE_STATUS_CHAT(state, value) {
    state.AppActiveUser.status = value
  },

  // ////////////////////////////////////////////
  // COMPONENT
  // ////////////////////////////////////////////

  // VxAutoSuggest
  UPDATE_STARRED_PAGE(state, payload) {
    // find item index in search list state
    const index = state.navbarSearchAndPinList.data.findIndex(
      (item) => item.index == payload.index
    )
    // update the main list
    state.navbarSearchAndPinList.data[index].highlightAction = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList.data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex(
        (item) => item.index == payload.index
      )
      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // The Navbar
  ADD_NOTIF_DATA(state, item) {
    if (item) {
      if (item.length === 1) {
        state.notifData.push(item[0])
      }
      if (item.length > 1) {
        state.notifData = item
      }
    }
  },
  // Counter Notif
  ADD_COUNTER(state, item) {
    state.counterNotif = state.counterNotif + 1
  },
  UPDATE_COUNTER(state, item) {
    // If item is provided, use it, otherwise calculate from unread notifications
    state.alertCounter = item !== undefined ? item : state.notifData.filter(notif => !notif.is_read).length
  },
  RESET_COUNTER(state, item) {
    state.counterNotif = 0
  },
  MARK_NOTIFICATION_AS_READ(state, notificationId) {
    // Find the notification in the notifData array and mark it as read
    const notification = state.notifData.find(notif => notif._id === notificationId)
    if (notification) {
      notification.is_read = true
    }
    // Update counter to decrease unread notifications
    if (state.alertCounter && state.alertCounter > 0) {
      state.alertCounter = state.alertCounter - 1
    }
  },
  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false
    let lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited = state.starredPages.slice(0, 10)
    state.starredPages = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })
    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },
}

export default mutations
